export const iconFontAwesomeHandsHandshakeSimple = (
	<i className="fa-solid fa-handshake-simple"></i>
);
